define('components/click-and-reveal-author/models/base-hotspot',[], function() {
    'use strict';
    /** =========================  base hotspot ========================= **/
    var BaseHotspotModel = Backbone.Model.extend({

        "defaults": function() {
            var DEFAULT_BOUNDS = BaseHotspotModel.DEFAULT_BOUNDS;
            return {
                "type": BaseHotspotModel.HOTSPOT_TYPE.BASE,
                "state": BaseHotspotModel.HOTSPOT_STATE.NOT_VIEWED,
                "bounds": {
                    "top": DEFAULT_BOUNDS.TOP,
                    "left": DEFAULT_BOUNDS.LEFT,
                    "height": DEFAULT_BOUNDS.HEIGHT,
                    "width": DEFAULT_BOUNDS.WIDTH
                },
                "cachedBounds": {
                    "top": DEFAULT_BOUNDS.TOP,
                    "left": DEFAULT_BOUNDS.LEFT,
                    "height": DEFAULT_BOUNDS.HEIGHT,
                    "width": DEFAULT_BOUNDS.WIDTH
                },
                "tooltips": [],
                "validateStateType": null,
                "hotspotAccText": ''
            };
        },

        /**
         * check if given value is present in object or not.
         * This is used to check if proper enum is used or not.
         * @method isValidValue
         * @return {Boolean}, true if value is present in object, else false
         * @param {Mixed}, val, string or Number, whose value to be check in object
         * @param {Object}, refObj, object in which value should be present
         */
        "isValidValue": function(val, refObj) {
            var index = null,
                isValid = false;
            for (index in refObj) {
                if (refObj[index] === val) {
                    isValid = true;
                    break;
                }
            }
            return isValid;
        },

        /**
         * Update hotspot type
         * @method updateType
         * @param {Number} type, any allowed type
         * @chainable
         **/
        "updateType": function(type) {
            if (this.isValidValue(type, BaseHotspotModel.HOTSPOT_TYPE)) {
                this.set("type", type);
            }
            return this;
        },

        /**
         * Update hotspot state
         * @method updateState
         * @param {Number} type, any allowed state
         * @chainable
         **/
        "updateState": function(state) {
            if (this.isValidValue(state, BaseHotspotModel.HOTSPOT_STATE)) {
                this.set("state", state);
            }
            return this;
        },

        /**
         * Update bounds value
         * @method updateBounds
         * @param {Object} bounds, hotspot position and size
         * @chainable
         */
        "updateBounds": function(bounds) {
            var index = null,
                modelBounds = this.get('cachedBounds');
            for (index in bounds) {
                if (modelBounds.hasOwnProperty(index)) {
                    modelBounds[index] = Number(bounds[index]);
                }
            }
            return this;
        },

        "updateBoundsForSaving": function() {
            this.set("bounds", _.extend({}, this.get("cachedBounds")));
        }
    }, {
        /**
         * Enum for hotspot state.
         *
         * @attribute HOTSPOT_STATE
         * @type Object
         */
        "HOTSPOT_STATE": {
            "VIEWED": 0,
            "NOT_VIEWED": 1
        },

        /**
         * Hotspot type's enum,
         * Different hotspot type's are as follows:
         *       HOTSPOT_TYPE.POINT : Point hotspot type
         *       HOTSPOT_TYPE.TEXT : Text hotspot type
         *       HOTSPOT_TYPE.IMAGE : Image hotspot
         *
         * @property HOTSPOT_TYPE
         * @type Object
         * @static
         * @public
         **/

        "HOTSPOT_TYPE": {
            "BASE": 0,
            "POINT": 1,
            "TEXT": 2,
            "IMAGE": 3,
            "PARAGRAPH": 4
        },

        /**
         * Default bounds for hotspot
         * @property {Object} DEFAULT_BOUNDS
         * @static
         */
        "DEFAULT_BOUNDS": {
            "TOP": 33,
            "LEFT": 0,
            "WIDTH": 100,
            "HEIGHT": 100
        },

        /**
         * Hotspot manager mode's enum,
         * different mode are as follows:
         *     MANAGER_MODE.CREATE : for creating hotspots.
         *     MANAGER_MODE.EDIT : for editing already created hotspots.
         *     MANAGER_MODE.DISPLAY : for displaying already created hotspots.
         *
         * @property MANAGER_MODE
         * @type Object
         * @static
         * @public
         **/
        "MANAGER_MODE": {
            "EDIT": 0,
            "DISPLAY": 1
        },

        "EVENTS": {
            "HOTSPOT_DRAGSTOP": "hotspot-dragstop"
        },
        "TEMPLATE_TEXT": {
            "ADD_TOOLTIP_BTN": "add tooltip"
        }
    });
    return BaseHotspotModel;
});

